var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixBtn",class:[_vm.scrollTop>0?'fixBtnAct':'']},[_c('div',{staticClass:"btnTop",on:{"click":_vm.scrollTops}}),_c('div',{staticClass:"btnBottom",on:{"click":_vm.scrollBottom}})])
}
var staticRenderFns = []

export { render, staticRenderFns }